// extracted by mini-css-extract-plugin
export default {"link":"EmployeeINNField-module--link--gqvGI"};